// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3SjlQ","selects":"Documents_selects__3ytrB"};